var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFlaskFox = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 18,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m11.726 9.807.318-4.372 1.295-3.113h-5.54l1.295 3.113.318 4.372.1 1.379.006 3.393h2.1l.006-3.393.102-1.379Z",
  fill: "url(#flask_fox_svg__a)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.754 8.965 14.79 7.806l1.198 1.812-1.79 3.486 2.366-.03h3.518l-1.328-4.109Z",
  fill: "url(#flask_fox_svg__b)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m6.35 7.806-3.964 1.16-1.318 4.107h3.517l2.359.03-1.789-3.485 1.196-1.812Z",
  fill: "url(#flask_fox_svg__c)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "m12.12 11.998-.5 2.584.364.25 2.212-1.729.068-1.734-2.144.629Z",
  fill: "url(#flask_fox_svg__d)"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "m6.881 11.369.06 1.735 2.213 1.728.364-.25-.5-2.584-2.137-.63Z",
  fill: "url(#flask_fox_svg__e)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "m19.595 5.988.637-3.092-.954-2.871-7.294 5.41 2.722 2.44 4.048 1.093.871-1.023-.38-.273.607-.553-.463-.363.607-.462-.4-.306Z",
  fill: "url(#flask_fox_svg__f)"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M1.545 5.988.908 2.896 1.862.025l7.295 5.41-2.723 2.44-4.048 1.09-.871-1.022.38-.273-.607-.553.463-.363-.607-.463.401-.303Z",
  fill: "url(#flask_fox_svg__g)"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "m5.153 9.618 1.728 1.75.06 1.736-1.788-3.486Z",
  fill: "url(#flask_fox_svg__h)"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "m15.988 9.618-1.79 3.486.068-1.735 1.722-1.751Z",
  fill: "url(#flask_fox_svg__i)"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "m14.553 16.08-2.57-1.248.204 1.674-.023.706 2.39-1.131ZM6.587 16.08l2.389 1.13-.016-.706.197-1.675-2.57 1.252Z",
  fill: "#FF9F5A"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "m16.562 13.073-2.009 3.008 4.298 1.182 1.229-4.19h-3.518Z",
  fill: "url(#flask_fox_svg__j)"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "m1.068 13.073 1.22 4.19 4.299-1.182-2.002-3.008H1.068Z",
  fill: "url(#flask_fox_svg__k)"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "m1.862.025 7.295 5.41-1.145-3.113L1.862.025Z",
  fill: "url(#flask_fox_svg__l)"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "m13.128 2.322-1.144 3.113 7.294-5.41-6.15 2.297Z",
  fill: "url(#flask_fox_svg__m)"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M6.35 7.806 5.154 9.618l4.26.19-.256-4.373L6.35 7.806Z",
  fill: "url(#flask_fox_svg__n)"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "m14.79 7.806-2.806-2.37-.258 4.371 4.261-.19-1.197-1.81Z",
  fill: "url(#flask_fox_svg__o)"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "m6.587 16.08 2.57-1.248-2.213-1.729-.357 2.978ZM11.984 14.832l2.57 1.249-.358-2.977-2.212 1.728Z",
  fill: "#9383FA"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "m14.199 13.104.357 2.977 2.008-3.008-2.365.03Z",
  fill: "url(#flask_fox_svg__p)"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "m6.942 13.104-.357 2.977-2.01-3.008 2.367.03Z",
  fill: "url(#flask_fox_svg__q)"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  d: "m15.988 9.618-4.262.19.394 2.19.63-1.319 1.516.69 1.722-1.751ZM6.881 11.369l1.509-.69.63 1.319.394-2.19-4.261-.19 1.728 1.75Z",
  fill: "#9C5ADD"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  d: "m12.12 11.998-.394-2.19-.1 1.378-.006 3.396.5-2.584Z",
  fill: "url(#flask_fox_svg__r)"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "m9.02 11.998.5 2.584-.006-3.396-.1-1.379-.394 2.19Z",
  fill: "url(#flask_fox_svg__s)"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  d: "m12.18 17.2.01-.696-.19-.167H9.14l-.183.167.017.705-2.39-1.128.835.682 1.698 1.175h2.904l1.698-1.175.834-.683-2.373 1.12Z",
  fill: "#DF7554"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  d: "m11.983 14.832-.363-.25h-2.1l-.363.25-.197 1.674.183-.166H12l.19.166-.207-1.675Z",
  fill: "#161616",
  stroke: "#161616",
  strokeWidth: 0.007,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  d: "m12.75 10.68-.63 1.318 2.146-.63-1.515-.689ZM8.39 10.68l.63 1.318-2.139-.63 1.509-.689Z",
  fill: "#161616"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "flask_fox_svg__a",
  x1: 10.57,
  y1: 2.321,
  x2: 10.57,
  y2: 14.581,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB7FE4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BCABFB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "flask_fox_svg__b",
  x1: 17.139,
  y1: 7.807,
  x2: 17.139,
  y2: 13.103,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B65FE5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ADA2FC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "flask_fox_svg__c",
  x1: 4.005,
  y1: 7.807,
  x2: 4.005,
  y2: 13.103,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B65FE5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ADA2FC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "flask_fox_svg__d",
  x1: 11.62,
  y1: 13.099,
  x2: 14.266,
  y2: 13.099,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C8A8F7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BAAAFB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "flask_fox_svg__e",
  x1: 6.882,
  y1: 13.099,
  x2: 9.52,
  y2: 13.099,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C8A8F7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BAAAFB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "flask_fox_svg__f",
  x1: 13.334,
  y1: 7.77,
  x2: 21.144,
  y2: 3.253,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#541758"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.429,
  stopColor: "#4F206C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#4D2577"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8B45B6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "flask_fox_svg__g",
  x1: 6.402,
  y1: 7.729,
  x2: -0.326,
  y2: 2.074,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#541758"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.429,
  stopColor: "#4F206C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#4D2577"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8B45B6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "flask_fox_svg__h",
  x1: 5.153,
  y1: 11.36,
  x2: 6.942,
  y2: 11.36,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BA86F3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.528,
  stopColor: "#B786F4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.899,
  stopColor: "#AE86F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AA86F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "flask_fox_svg__i",
  x1: 14.198,
  y1: 11.36,
  x2: 15.987,
  y2: 11.36,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BA86F3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.528,
  stopColor: "#B786F4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.899,
  stopColor: "#AE86F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AA86F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "flask_fox_svg__j",
  x1: 17.317,
  y1: 13.073,
  x2: 17.317,
  y2: 17.263,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#906EF7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#575ADE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "flask_fox_svg__k",
  x1: 3.827,
  y1: 13.073,
  x2: 3.827,
  y2: 17.263,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#906EF7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#575ADE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "flask_fox_svg__l",
  x1: 1.863,
  y1: 2.73,
  x2: 9.156,
  y2: 2.73,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BB65ED"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E560E3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "flask_fox_svg__m",
  x1: 11.984,
  y1: 2.73,
  x2: 19.277,
  y2: 2.73,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E560E3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.295,
  stopColor: "#DE61E5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#CC63E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BB65ED"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "flask_fox_svg__n",
  x1: 7.284,
  y1: 5.435,
  x2: 7.284,
  y2: 9.807,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DC69E6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C289F3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "flask_fox_svg__o",
  x1: 13.857,
  y1: 5.435,
  x2: 13.857,
  y2: 9.807,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DC69E6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C289F3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "flask_fox_svg__p",
  x1: 15.38,
  y1: 9.239,
  x2: 15.38,
  y2: 17.035,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6848BA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.336,
  stopColor: "#6356D5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "flask_fox_svg__q",
  x1: 5.76,
  y1: 13.073,
  x2: 5.76,
  y2: 16.081,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6848BA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.336,
  stopColor: "#6356D5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "flask_fox_svg__r",
  x1: 11.87,
  y1: 14.581,
  x2: 11.87,
  y2: 9.807,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BA86F3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.528,
  stopColor: "#B786F4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.899,
  stopColor: "#AE86F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AA86F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "flask_fox_svg__s",
  x1: 9.02,
  y1: 12.194,
  x2: 9.52,
  y2: 12.194,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BA86F3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.528,
  stopColor: "#B786F4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.899,
  stopColor: "#AE86F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AA86F6"
})))));
export { SvgFlaskFox as ReactComponent };
export default "data:image/svg+xml;base64,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";